module.exports = "<location-picker [options]=\"locationOptions\" (locationSelected)=\"locationSelected($event)\"></location-picker>\r\n<div style=\"width: 100%; display: flex; justify-content: end;\">\r\n\r\n    <button style=\"margin: 20px; margin-top: 0;\" (click)=\"closeDialog()\" mat-flat-button color=\"accent\">Confirm</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utilities/Dialog/dialog/location-picker-dialog/location-picker-dialog.component.html
// module id = ./src/app/utilities/Dialog/dialog/location-picker-dialog/location-picker-dialog.component.html
// module chunks = main